/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Subscribed_Success_BtnInputs */

const en_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Now`)
};

const ar_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ الآن`)
};

const de_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt beginnen`)
};

const es_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza ahora`)
};

const fr_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer`)
};

const it_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia ora`)
};

const ja_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ始める`)
};

const ko_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 시작하기`)
};

const pt_br_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar agora`)
};

const ru_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать`)
};

const th_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มต้นตอนนี้`)
};

const tr_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Başla`)
};

const zh_cn_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`马上开始`)
};

const zh_tw_onboarding_paywall_subscribed_success_btn = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`馬上開始`)
};

/**
* | output |
* | --- |
* | "Start Now" |
*
* @param {Onboarding_Paywall_Subscribed_Success_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_subscribed_success_btn = /** @type {((inputs?: Onboarding_Paywall_Subscribed_Success_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Subscribed_Success_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "ar") return ar_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "de") return de_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "es") return es_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "fr") return fr_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "it") return it_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "ja") return ja_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "ko") return ko_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "ru") return ru_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "th") return th_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "tr") return tr_onboarding_paywall_subscribed_success_btn(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_subscribed_success_btn(inputs)
	return zh_tw_onboarding_paywall_subscribed_success_btn(inputs)
});